:host{z-index:inherit}.toolbar-grid{right:var(--ursa--scrollbar-width);bottom:var(--ursa--scrollbar-width)}h3-coordinates-box{position:absolute;bottom:var(--ursa--scrollbar-width);right:var(--ursa--scrollbar-width)}.output-controls{display:flex;gap:4px}
/*# sourceMappingURL=vector-tagging-toolbars.component.css.map */
